var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-entity',{attrs:{"rotation":"90 0 0"}},[_c('a-entity',{attrs:{"geometry":_vm.geometry,"material":_vm.material,"animation":_vm.rotationAnimation,"animation__pos":_vm.bounceAnimation,"rotation":"45 0 45"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }